import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SiteService } from './site.service';

@Injectable({
  providedIn: 'root'
})
export class SiteGuard  {
  constructor(private _siteService: SiteService, private _router: Router){};

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      const isAuthenticated = await this._siteService.isSiteAuthenticated();
      if(isAuthenticated){
        return true;
      }

      this._router.navigate(['signin']);
      return false;
  }
  
}
